var w = (d, n, r) => new Promise((a, s) => {
  var f = (e) => {
    try {
      o(r.next(e));
    } catch (m) {
      s(m);
    }
  }, c = (e) => {
    try {
      o(r.throw(e));
    } catch (m) {
      s(m);
    }
  }, o = (e) => e.done ? a(e.value) : Promise.resolve(e.value).then(f, c);
  o((r = r.apply(d, n)).next());
});
import { defineComponent as x, ref as E, watch as O, onMounted as y, onBeforeUnmount as B, createElementBlock as M, openBlock as C, withDirectives as K, createBlock as b, createCommentVNode as L, createElementVNode as _, vShow as W, Transition as D, withCtx as N, renderSlot as S } from "vue";
import { a as V, e as A, f as U, i as X, W as F, _ as P } from "./exports-CVYl7bes.js";
const Y = {
  class: "math-inline__loading",
  role: "status",
  "aria-live": "polite"
}, $ = /* @__PURE__ */ x({
  __name: "MathInlineNode",
  props: {
    node: {}
  },
  setup(d) {
    const n = d, r = E(null), a = E(null);
    let s = !1, f = 0, c = !1, o = null;
    const e = E(!0), m = V();
    let l = null;
    function R() {
      return w(this, null, function* () {
        if (!n.node.content || !a.value || c)
          return;
        o && (o.abort(), o = null);
        const i = ++f, u = new AbortController();
        if (o = u, !s)
          try {
            !l && r.value && (l = m(r.value)), yield l == null ? void 0 : l.whenVisible;
          } catch (t) {
          }
        A(n.node.content, !1, {
          // Inline math should not wait on worker slots; fallback to sync render immediately
          timeout: 1500,
          waitTimeout: 0,
          maxRetries: 0,
          signal: u.signal
        }).then((t) => {
          c || i !== f || a.value && (a.value.innerHTML = t, e.value = !1, s = !0);
        }).catch((t) => w(null, null, function* () {
          if (c || i !== f || !a.value)
            return;
          const p = (t == null ? void 0 : t.code) || (t == null ? void 0 : t.name), k = p === "WORKER_INIT_ERROR" || (t == null ? void 0 : t.fallbackToRenderer), I = p === F || p === "WORKER_TIMEOUT", h = p === "KATEX_DISABLED";
          if (k || I) {
            const T = yield U();
            if (T) {
              try {
                const v = T.renderToString(n.node.content, { throwOnError: n.node.loading, displayMode: !1 });
                e.value = !1, a.value.innerHTML = v, s = !0, X(n.node.content, !1, v);
              } catch (v) {
              }
              return;
            }
          }
          if (h) {
            e.value = !1, a.value.textContent = n.node.raw;
            return;
          }
          s || (e.value = !h), n.node.loading ? h && (a.value.textContent = n.node.raw) : (e.value = !1, a.value.textContent = n.node.raw);
        }));
      });
    }
    return O(
      () => n.node.content,
      () => {
        R();
      }
    ), y(() => {
      R();
    }), B(() => {
      var i;
      c = !0, o && (o.abort(), o = null), (i = l == null ? void 0 : l.destroy) == null || i.call(l), l = null;
    }), (i, u) => (C(), M("span", {
      ref_key: "containerEl",
      ref: r,
      class: "math-inline-wrapper"
    }, [
      K(_("span", {
        ref_key: "mathElement",
        ref: a,
        class: "math-inline"
      }, null, 512), [
        [W, !e.value]
      ]),
      e.value ? (C(), b(D, {
        key: 0,
        name: "table-node-fade"
      }, {
        default: N(() => [
          _("span", Y, [
            S(i.$slots, "loading", { isLoading: e.value }, () => [
              u[0] || (u[0] = _("span", {
                class: "math-inline__spinner animate-spin",
                "aria-hidden": "true"
              }, null, -1)),
              u[1] || (u[1] = _("span", { class: "sr-only" }, "Loading", -1))
            ], !0)
          ])
        ]),
        _: 3
      })) : L("", !0)
    ], 512));
  }
}), g = /* @__PURE__ */ P($, [["__scopeId", "data-v-fbd3ae11"]]);
g.install = (d) => {
  d.component(g.__name, g);
};
export {
  g as default
};
